import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { AsyncPipe, CommonModule, JsonPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField, MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgChartsModule } from 'ng2-charts';
import { AutoFocusDirective } from './auto-focus.directive';
import { BankIdCheatComponent } from './bank-id-cheat/bank-id-cheat.component';
import { BeautifulPaginationComponent } from './beautiful-pagination/beautiful-pagination.component';
import { ChooserComponent } from './chooser/chooser.component';
import { ComponentContainerComponent } from './component-container/component-container.component';
import { DebugDirective } from './directives/debug.directive';
import { HideTabHeaderDirective } from './directives/hideTabHeader.directive';
import { StyleDirective } from './directives/style.directive';
import { EmptyPageComponent } from './empty-page/empty-page.component';
import { LangSelectComponent } from './lang-select/lang-select.component';
import { LetterAvatarGenericComponent } from './letter-avatar-generic/letter-avatar.component';
import { LocaleDatePipe } from './locale-date.pipe';
import { MoneydisplayPipe } from './moneydisplay.pipe';
import { OrgbrainCardComponent } from './orgbrain-card/orgbrain-card.component';
import { InfoBoxOpenButtonComponent } from './orgbrain-dialogs/info-box/info-box-open-button.component';
import { InfoBoxComponent } from './orgbrain-dialogs/info-box/info-box.component';
import { LoadingSpinnerComponent } from './orgbrain-dialogs/loading-spinner/loading-spinner.component';
import { OrgBrainDialogsModule } from './orgbrain-dialogs/orgbraindialogs.module';
import { SimpleSpinnerComponent } from './orgbrain-dialogs/simple-spinner/simple-spinner.component';
import { TextPromptComponent } from './orgbrain-dialogs/text-prompt/support-note.component';
import { OrgbrainHelpComponent } from './orgbrain-help/orgbrain-help.component';
import { OrgbrainLogoComponent } from './orgbrain-logo/orgbrain-logo.component';
import { OrgbrainTabDirective } from './orgbrain-tabs/orgbrain-tab.directive';
import { OrgbrainTabsComponent } from './orgbrain-tabs/orgbrain-tabs.component';
import { OrgbrainMatTableDataSource } from './OrgbrainDataSource';
import { PageNotFoundDialogComponent } from './page-not-found-dialog/page-not-found-dialog.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { PowerStepperComponent } from './power-stepper/power-stepper.component';
import { PrettyjsonPipe } from './prettyjson.pipe';
import { ProgressStepperComponent } from './progress-stepper/progress-stepper.component';
import { RadioSelectCardComponent } from './radio-select-card/radio-select-card.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SimpleSegmentedButtonComponent } from './segmented-buttons/segmented-buttons.component';
import { SnackMessComponent } from './snack-mess/snack-mess.component';
import { BottomButtonsComponent } from './style/bottom-buttons/bottom-buttons.component';
import { OrgbrainTableComponent } from './style/orgbrain-table/orgbrain-table.component';
import { OrgbrainToastComponent } from './style/orgbrain-toastr';
import { TitleBarComponent } from './style/title-bar/title-bar.component';
import { SuperInfoBoxComponent } from './super-info-box/super-info-box.component';
import { SwitchComponent } from './switch/switch.component';
import { TestResultComponent } from './test-result/test-result.component';
import { ThousandseparatordisplayPipe } from './thousandseparatordisplay.pipe';
import { TreeViewComponent } from './tree-view/tree-view.component';
import { UserItemComponent } from './user-item/user-item.component';
import { WarningBoxComponent } from './warning-box/warning-box.component';

@NgModule({
  imports: [
    OrgbrainHelpComponent,
    CommonModule,
    MatSnackBarModule,
    OverlayModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    OrgBrainDialogsModule,
    MatTooltipModule,
    MatCardModule,
    DragDropModule,
    PortalModule,
    NgChartsModule,
    MatCheckboxModule,
    MatInputModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormField,
    MatInputModule,
    MatMenuModule,
    MatChipsModule,
    ThousandseparatordisplayPipe,
    MatDividerModule,
    MoneydisplayPipe,
    MatDialogModule,
    MatProgressBarModule,
    MatSelectModule,
    MatOptionModule,
    RouterModule,
    AsyncPipe,
    JsonPipe,
    MatTableModule,
  ],

  declarations: [
    ProgressStepperComponent,
    SwitchComponent,
    PageNotFoundComponent,
    StyleDirective,
    DebugDirective,
    AutoFocusDirective,
    HideTabHeaderDirective,
    OrgbrainCardComponent,
    SnackMessComponent,
    RadioSelectCardComponent,
    TitleBarComponent,
    OrgbrainTabsComponent,
    OrgbrainTabDirective,
    PrettyjsonPipe,
    LocaleDatePipe,
    SafeHtmlPipe,
    TreeViewComponent,
    LangSelectComponent,
    SimpleSpinnerComponent,
    EmptyPageComponent,
    OrgbrainToastComponent,
    PowerStepperComponent,
    TextPromptComponent,
    BankIdCheatComponent,
    ComponentContainerComponent,
    OrgbrainToastComponent,
    OrgbrainLogoComponent,
    PageNotFoundDialogComponent,
    SimpleSegmentedButtonComponent,
    SuperInfoBoxComponent,
    BottomButtonsComponent,
    BeautifulPaginationComponent,
    OrgbrainTableComponent,
    TestResultComponent,
    WarningBoxComponent,
    ChooserComponent,
    LetterAvatarGenericComponent,
    UserItemComponent,
    PhoneInputComponent,
    SimpleSegmentedButtonComponent,
    TitleBarComponent,
  ],

  exports: [
    ProgressStepperComponent,
    PhoneInputComponent,
    PageNotFoundComponent,
    SwitchComponent,
    OrgbrainLogoComponent,
    RadioSelectCardComponent,
    OrgbrainTabDirective,
    ThousandseparatordisplayPipe,
    OrgbrainCardComponent,
    TitleBarComponent,
    LocaleDatePipe,
    EmptyPageComponent,
    OrgbrainTabsComponent,
    OrgBrainDialogsModule,
    SuperInfoBoxComponent,
    PrettyjsonPipe,
    SimpleSegmentedButtonComponent,
    TreeViewComponent,
    LangSelectComponent,
    LoadingSpinnerComponent,
    DragDropModule,
    SafeHtmlPipe,
    MoneydisplayPipe,
    SimpleSpinnerComponent,
    StyleDirective,
    DebugDirective,
    HideTabHeaderDirective,
    PowerStepperComponent,
    MatMenuModule,
    TextPromptComponent,
    OrgbrainHelpComponent,
    BottomButtonsComponent,
    BankIdCheatComponent,
    OrgbrainToastComponent,
    ComponentContainerComponent,
    PageNotFoundDialogComponent,
    InfoBoxComponent,
    InfoBoxOpenButtonComponent,
    BeautifulPaginationComponent,
    OrgbrainTableComponent,
    AutoFocusDirective,
    TestResultComponent,
    WarningBoxComponent,
    ChooserComponent,
    LetterAvatarGenericComponent,
    UserItemComponent,
    SimpleSegmentedButtonComponent,
    TitleBarComponent,
  ],
})
export class LibAngularUtilModule {}
export * from './beautiful-pagination/beautiful-pagination.component';
export { BisnodeService } from './bisnode.service';
export { BrregHelperService } from './brreg-helper.service';
export * from './date-util.service';
export * from './device.service';
export * from './landing-params.service';
export * from './locale-service';
export { MessageService } from './message.service';
export * from './mongoose-util.service';
export * from './orgbrain-dialogs/confirmdialog.component';
export * from './orgbrain-dialogs/deletedialog.component';
export * from './orgbrain-dialogs/info';
export * from './orgbrain-dialogs/orgbrainDialog.service';
export * from './orgbrain-dialogs/orgbraindialogs.module';
export { TextPromptComponent } from './orgbrain-dialogs/text-prompt/support-note.component';
export * from './orgbrain-layout.service';
export { OrgbrainLogoComponent } from './orgbrain-logo/orgbrain-logo.component';
export { PageNotFoundDialogComponent } from './page-not-found-dialog/page-not-found-dialog.component';
export { PageNotFoundComponent } from './page-not-found/page-not-found.component';
export * from './phoneValidator';
export { StepDeclaration } from './power-stepper/power-stepper.component';
export * from './prettyjson.pipe';
export * from './reloadHelper';
export * from './safe-html.pipe';
export * from './savefile';
export * from './segmented-buttons/segmented-buttons.component';
export * from './services/component-registry.service';
export * from './services/decoration.service';
export * from './services/snack2toastr.service';
export * from './services/style-preferences.service';
export { SnackMessComponent } from './snack-mess/snack-mess.component';
export {
  OrgbrainTableData,
  OrgbrainTableMetaItem,
} from './style/orgbrain-table/orgbrain-table.component';
export * from './style/orgbrain-toastr';
export * from './style/title-bar/title-bar-button';
export { TitleBarComponent } from './style/title-bar/title-bar.component';
export * from './test-result/test-result.component';
export * from './thousandseparatordisplay.pipe';
export * from './user-item/user-item.component';
export { SharedUtilService } from './util.service';
export * from './uuid.service';
export { OrgbrainMatTableDataSource };
